import React from "react";
import { Container, Divider } from "@mui/material";
import HomeBanner from "../components/HomeBanner";
import DemoPanels from "../components/DemoPanels";
import Header from "../components/Header/AppBar";
import Footer from "../components/Footer";
import { Box } from "@mui/material";

function Home(props) {
  const gridMargin = "0 24px 0 24px";
  return (
    <Box sx={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}>
      <Header {...props} />
      <Container maxWidth="lg">
        <HomeBanner gridMargin={gridMargin} />
        <Divider sx={{ margin: gridMargin, paddingTop: "60px" }} />
        <DemoPanels gridMargin={gridMargin} />
      </Container>
      <Footer />
    </Box>
  );
}

export default Home;
